module.exports = [
  {
    name: 'demo8',
    script: 'node_modules/next/dist/bin/next',
    args: 'start',
    instance: 'max',
    exec_mode: 'cluster',
    env: { PORT: 3000, FRONTEND: 'demo8' },
  },
  {
    name: 'demo-uk',
    script: 'node_modules/next/dist/bin/next',
    args: 'start',
    instance: 'max',
    exec_mode: 'cluster',
    env: { PORT: 3005, FRONTEND: 'demo-uk' },
  },
  {
    name: 'demo-de',
    script: 'node_modules/next/dist/bin/next',
    args: 'start',
    instance: 'max',
    exec_mode: 'cluster',
    env: { PORT: 3013, FRONTEND: 'demo-de' },
  },
  {
    name: 'demo-ml',
    script: 'node_modules/next/dist/bin/next',
    args: 'start',
    instance: 'max',
    exec_mode: 'cluster',
    env: { PORT: 3012, FRONTEND: 'demo-ml' },
  },
  {
    name: 'test-site',
    script: 'node_modules/next/dist/bin/next',
    args: 'start',
    instance: 'max',
    exec_mode: 'cluster',
    env: { PORT: 3750 },
  },
];
